import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import ServicesView from '../views/ServicesView.vue'
import CasesView from '../views/CasesView.vue'
import NewsView from '../views/NewsView.vue'
import TalentView from '../views/TalentView.vue'
import ContactView from '../views/ContactView.vue'
import { getStoredLanguage, translateText } from '../i18n/localLanguage'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页' }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: { title: '关于我们' }
  },
  {
    path: '/services',
    name: 'services',
    component: ServicesView,
    meta: { title: '解决方案' }
  },
  {
    path: '/cases',
    name: 'cases',
    component: CasesView,
    meta: { title: '产品中心' }
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView,
    meta: { title: '平台介绍' }
  },
  {
    path: '/talent',
    name: 'talent',
    component: TalentView,
    meta: { title: '加入代理' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView,
    meta: { title: '联系我们' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 82 }
      }
    }

    return { x: 0, y: 0 }
  }
})

router.afterEach(to => {
  const pageTitle = translateText(to.meta.title || '千讯云创', getStoredLanguage())
  const siteTitle = translateText('千讯云创', getStoredLanguage())
  document.title = `${pageTitle} - ${siteTitle}`
})

window.addEventListener('site-language-change', () => {
  const currentRoute = router.currentRoute
  const pageTitle = translateText(currentRoute.meta.title || '千讯云创', getStoredLanguage())
  const siteTitle = translateText('千讯云创', getStoredLanguage())

  document.title = `${pageTitle} - ${siteTitle}`
})

export default router
